<template>
  <div v-if="hasResults" class="px-2 pb-1">
    <div
      class="flex items-center gap-2 px-3 pb-1.5 pt-3 text-xs font-semibold uppercase tracking-wider text-obsidian-400"
    >
      <component :is="icon" class="h-3.5 w-3.5" />
      {{ label }}
    </div>
    <slot />
  </div>
</template>

<script setup lang="ts">
import type { Component } from 'vue';

defineProps<{
  label: string;
  icon: Component;
  hasResults: boolean;
}>();
</script>
